import { cn } from "@/modules/lib/utils"
import { VideoIcon } from "lucide-react"

export function VideoThumbnail({ url, className }: { url: string; className?: string }) {
  return (
    <>
      <video
        src={url}
        className={cn("h-full w-full rounded-lg bg-neutral-300 object-cover", className)}
        preload="metadata"
        muted
        playsInline
        style={{ pointerEvents: "none" }}
      />
      <VideoIcon className="size-2xl center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-neutral-100" />
    </>
  )
}
